import { useState } from 'react';
import YouTube, { ytThumb } from './YouTube';
import { Horizon, Peeks, splitArt } from './Art';

export default function Watch({ heading, videos, art }) {
  const [index, setIndex] = useState(0);
  const [wantsPlay, setWantsPlay] = useState(false);
  const current = videos[index] || videos[0];
  if (!current) return null;
  const { peeks, horizon } = splitArt(art);

  return (
    <section id="watch" className={`sec sec--sea watch ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="watch-title">
      <div className="watch-tiles" aria-hidden="true" />
      <Peeks items={peeks} />
      <div className="wrap">
        <h2 id="watch-title" className="display">{heading}</h2>
        <div className="watch-grid">
          <div className="watch-stage">
            <YouTube key={`${current.id}-${wantsPlay}`} id={current.id} title={current.title} autoPlay={wantsPlay} />
            <div className="watch-now">
              <h3 className="display display--s">{current.title}</h3>
              {current.desc && <p>{current.desc}</p>}
            </div>
          </div>

          {videos.length > 1 && (
            <ul className="playlist" aria-label="More videos">
              {videos.map((v, i) => (
                <li key={v.key}>
                  <button
                    type="button"
                    className="playlist-item"
                    aria-current={i === index ? 'true' : undefined}
                    onClick={() => { setIndex(i); setWantsPlay(true); }}
                  >
                    <span className="playlist-thumb"><img src={ytThumb(v.id)} alt="" loading="lazy" /></span>
                    <span className="playlist-text">
                      <strong>{v.title}</strong>
                      {v.desc && <span>{v.desc}</span>}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
